import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import { AuthProvider } from './hooks/useAuth.jsx';
import { SocketProvider } from './hooks/useSocket.jsx';
import { LeaveToastListener } from './components/LeaveToastListener.jsx';
import './index.css';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // 30s stale time — current state of an attendance dashboard updates
            // through Socket.io anyway, so polling is unnecessary
            staleTime: 30 * 1000,
            retry: 1,
            refetchOnWindowFocus: true,
        },
    },
});

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <AuthProvider>
                    <SocketProvider>
                        <App />
                        <LeaveToastListener />
                    </SocketProvider>
                </AuthProvider>
            </BrowserRouter>
        </QueryClientProvider>
    </StrictMode>
);
